var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCounter1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "face-content"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M16.6667 29.1665C16.6667 29.1665 19.7917 33.3332 25 33.3332C30.2083 33.3332 33.3333 29.1665 33.3333 29.1665M35.4167 19.2498C34.5937 20.2602 33.4687 20.8332 32.2917 20.8332C31.1146 20.8332 30.0208 20.2602 29.1667 19.2498M20.8333 19.2498C20.0104 20.2602 18.8854 20.8332 17.7083 20.8332C16.5312 20.8332 15.4375 20.2602 14.5833 19.2498M45.8333 24.9998C45.8333 36.5058 36.5059 45.8332 25 45.8332C13.4941 45.8332 4.16666 36.5058 4.16666 24.9998C4.16666 13.4939 13.4941 4.1665 25 4.1665C36.5059 4.1665 45.8333 13.4939 45.8333 24.9998Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounter1);
export default __webpack_public_path__ + "static/media/counter1.a1d37d6414cf1892161a1c8c98e807f8.svg";
export { ForwardRef as ReactComponent };